import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { colorPalette } from '@shared/config/colorsConfig';

export interface IProgressBarProps {
  percentage: number;
  complete?: boolean;
  trackColor?: string;
  fillColor?: string;
  completeFillColor?: string;
  completeTrackColor?: string;
  label?: string;
}

const ProgressBar: React.FC<IProgressBarProps> = ({
  percentage,
  complete = false,
  trackColor,
  fillColor = colorPalette.secondary[600],
  completeFillColor = colorPalette.success[500],
  completeTrackColor,
  label,
}) => {
  const width = Math.max(0, Math.min(100, percentage));
  const bordered = !trackColor;
  const track = complete && completeTrackColor ? completeTrackColor : trackColor;

  const bar = (
    <View
      className={`overflow-hidden h-3 rounded-full ${bordered ? 'bg-white border border-gray-300' : ''}`}
      style={{ backgroundColor: track }}
    >
      <View
        className="h-full rounded-full"
        style={{
          width: `${width}%`,
          minWidth: width > 0 ? 14 : 0,
          backgroundColor: complete ? completeFillColor : fillColor,
        }}
      />
    </View>
  );

  if (!label) {
    return bar;
  }

  return (
    <View className="flex-row items-center mb-2">
      <View className="flex-[12]">{bar}</View>
      <View className="flex-[3] pl-1">
        <Text className="text-right">{label}</Text>
      </View>
    </View>
  );
};

export default ProgressBar;
